import appLocaleData from 'react-intl/locale-data/tr';

const TrLang = {
    messages: {},
    locale: 'tr-TR',
    data: appLocaleData,
};

export default TrLang;
